import AxiosInstance from 'axios'
import type { SelectedCustomer } from '~/types/selectedCustomer'

export default defineNuxtPlugin((nuxtApp) => {
  //const runtimeConfig = useRuntimeConfig()
  const appConfigStore = useAppConfigStore()
  const appConfig = appConfigStore.appConfig!
  const accessToken = useCookie(appConfig.public.CLIENT_ACCESS_TOKEN_COOKIE)
  const selectedShowCustomerCookie = useCookie<SelectedCustomer>('selectedShowCustomer')

  const api = AxiosInstance.create({
    baseURL: appConfig.public.API_URL,
    withCredentials: true,
    headers: {
      common: {
        'System-Name': 'N41_VENDOR_WEB',
        'Accept-Language': 'en-US,en;',
        Accept: 'application/json, text/plain, */*'
      },
      delete: {},
      get: {},
      post: {},
      put: {}
    }
  })

  api.interceptors.request.use((config) => {
    if (accessToken.value) {
      config.headers.Authorization = `Bearer ${accessToken.value}`
    }
    if (selectedShowCustomerCookie?.value?.code) {
      config.headers['X-Customer-Code'] = selectedShowCustomerCookie.value.code
    }
    return config
  })

  api.interceptors.response.use(
    (res) => {
      const contentType = res.headers['content-type']
      //console.log(`res.headers['content-type']: ${contentType}`)
      //const contentLength = res.headers['Content-Length']
      //console.log(`res.headers['Content-Length']: ${contentLength}`)
      if (contentType === 'application/json') {
        return res.data
      }
      return res
    },
    async (err) => {
      const originalRequest = err.config
      if (err.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        try {
          //console.log('>> Err 401 Refresh Token Request')
          const { refresh } = useAuth()
          await refresh()
          //console.log('>> Retry Ori Request with new Refresh Token', accessToken.value)
          originalRequest.headers.Authorization = `Bearer ${accessToken.value}`
          return api(originalRequest)
        } catch (refreshErr) {
          //console.log('>> Err Refresh Token Exception', refreshErr)
          accessToken.value = null
          return Promise.reject(refreshErr)
        }
      }
      return Promise.reject(err)
    }
  )

  nuxtApp.provide('axios', api)
  // return {
  //   provide: {
  //     api
  //   }
  // }
})
